<template>
  <popup-modal ref="popup">
    <v-card>
      <v-toolbar color="primary" dark>
        Добавление контакта
      </v-toolbar>

      <v-card-text class="mt-4">
        <v-form ref="Form">
          <v-col cols="12" md="12">
            <v-text-field v-model="form.fio" label="ФИО" required></v-text-field>
          </v-col>

          <v-col cols="12" md="12">
            <v-text-field v-model="form.position" label="Должность" required></v-text-field>
          </v-col>

          <v-col cols="12" md="12">
            <v-text-field v-model="form.phone" label="Телефон" required></v-text-field>
          </v-col>

          <v-col cols="12" md="12">
            <v-text-field v-model="form.email" label="Электронная почта" required></v-text-field>
          </v-col>
        </v-form>
      </v-card-text>

      <!--                Actions-->
      <v-card-actions>
        <div class="flex-grow-1"></div>

        <v-btn @click="Negative" text>{{ $t('common.button_cancel') }}</v-btn>
        <v-btn @click="Positive" color="primary">{{ $t('common.button_ok') }}</v-btn>
      </v-card-actions>
    </v-card>
  </popup-modal>
</template>

<script>
import PopupModal from "@/components/PopupModal";

export default {
  name: "DialogAddContact",
  components: { PopupModal },
  data: () => ({
    form: {
      fio: "",
      position: "",
      phone: "",
      email: "",
    },

    // Private variables
    resolvePromise: undefined,
    rejectPromise: undefined,
  }),
  methods: {
    show(opts = {}) {
      this.form.fio       = opts.fio
      this.form.position  = opts.position
      this.form.phone     = opts.phone
      this.form.email     = opts.email

      // Once we set our config, we tell the popup modal to open
      this.$refs.popup.open(false, true);

      // Return promise so the caller can get results
      return new Promise((resolve, reject) => {
        this.resolvePromise = resolve;
        this.rejectPromise = reject;
      });
    },

    Positive() {
      this.$refs.popup.close();
      this.resolvePromise({ answer: "positive", form: this.form });
    },
    Negative() {
      this.$refs.popup.close();
      this.resolvePromise({ answer: "negative" });
    },
  },
};
</script>
